import { render, staticRenderFns } from "./recordCertificate.vue?vue&type=template&id=7ccf750f&scoped=true"
import script from "./recordCertificate.vue?vue&type=script&lang=js"
export * from "./recordCertificate.vue?vue&type=script&lang=js"
import style0 from "./recordCertificate.vue?vue&type=style&index=0&id=7ccf750f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccf750f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ccf750f')) {
      api.createRecord('7ccf750f', component.options)
    } else {
      api.reload('7ccf750f', component.options)
    }
    module.hot.accept("./recordCertificate.vue?vue&type=template&id=7ccf750f&scoped=true", function () {
      api.rerender('7ccf750f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/offlinePayment/components/recordCertificate.vue"
export default component.exports